import { render, staticRenderFns } from "./LayoutQrCode.vue?vue&type=template&id=40a6fb3d&"
import script from "./LayoutQrCode.vue?vue&type=script&lang=js&"
export * from "./LayoutQrCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports